module.exports = __webpack_public_path__ + "img/dentalfit_7_b.24dc98c3.jpg";